import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "dimmer",
  id: "dimmer_loading"
}

import {Dimmer} from 'bootstrap-italia'
import {onMounted, watch} from "vue";
import {useLoadingSpinnerStore} from "@/stores/loadingSpinner";


export default /*@__PURE__*/_defineComponent({
  __name: 'LoadingPage',
  setup(__props) {

// @ts-ignore
onMounted(() => {
  const myDimmer = document.getElementById('dimmer_loading')
  const dimmer = new Dimmer(myDimmer)

  const loadingSpinnerStore = useLoadingSpinnerStore();
  watch(loadingSpinnerStore.loading, (value: Map<string, boolean>) => {
    if(!!dimmer){
      const inLoading = [...value.values()].some((el) => el);
      inLoading ? dimmer.show() : dimmer.hide();
    }
  }, {deep: true})

})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("div", { class: "dimmer-inner" }, [
      _createElementVNode("div", { class: "dimmer-icon" }, [
        _createElementVNode("div", { class: "progress-spinner progress-spinner-active" }, [
          _createElementVNode("span", { class: "visually-hidden" }, "Caricamento...")
        ])
      ])
    ], -1)
  ]))]))
}
}

})